'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generateContentHash;
/*  weak */
/**
 * generates a hashcode from a string
 * taken from http://stackoverflow.com/a/7616484
 *
 * @param {string} str - str used to generate the unique hash code
 * @return {string} compressed content hash
 */
function generateContentHash(str) {
  var hash = 0;
  var iterator = 0;
  var char = void 0;
  var length = str.length;

  // return a `s` for empty strings
  // to symbolize `static`
  if (length === 0) {
    return '';
  }

  for (; iterator < length; ++iterator) {
    char = str.charCodeAt(iterator);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }

  return '-' + hash.toString(36);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/fela/lib/utils/generateContentHash.js
// module id = 437
// module chunks = 0